import { render, staticRenderFns } from "./WizardTitleDecorationIconMobile.vue?vue&type=template&id=162a4608&scoped=true&"
import script from "./WizardTitleDecorationIconMobile.vue?vue&type=script&lang=ts&"
export * from "./WizardTitleDecorationIconMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a4608",
  null
  
)

export default component.exports